"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketHeartBeat = void 0;
// reference: https://github.com/zimv/websocket-heartbeat-js/blob/master/lib/index.js
class WebSocketHeartBeat {
    constructor(rws, queryParams, options) {
        this.rws = rws;
        this.queryParams = queryParams;
        this.options = options;
        this.check = () => {
            this.reset();
            this.start();
        };
        this.reset = () => {
            this.pingTimeoutId && clearTimeout(this.pingTimeoutId);
            this.pongTimeoutId && clearTimeout(this.pongTimeoutId);
            this.pingTimeoutId = undefined;
            this.pongTimeoutId = undefined;
        };
        this.start = () => {
            var _a;
            if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.pingEnabled)) {
                return;
            }
            this.pingTimeoutId = setTimeout(() => {
                this.rws.send(JSON.stringify({
                    action: 'ping',
                    tenantId: this.queryParams.tenantId,
                    retailerId: this.queryParams.retailerId,
                }));
                this.pongTimeoutId = setTimeout(() => {
                    this.rws.reconnect();
                }, this.pongTimeout);
            }, this.pingTimeout);
        };
        this.pingTimeout = (options === null || options === void 0 ? void 0 : options.pingTimeout) || 2000;
        this.pongTimeout = (options === null || options === void 0 ? void 0 : options.connectionTimeout) || 4000;
    }
}
exports.WebSocketHeartBeat = WebSocketHeartBeat;
//# sourceMappingURL=WebSocketHeartBeat.js.map